import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tableFilter'
})
export class TableFilterPipe implements PipeTransform {

  transform(list: any[], filters: any) {
    // const keys       = Object.keys(filters).filter(key => filters[key]);
    return filters.length ?

                            list.filter((s:any)=>
                              s.fullName.toLowerCase( ).includes(filters.toLowerCase()) ||
                                s.studentId.toString().toLowerCase( ).includes(filters.toLowerCase())
                            )


                          : list;




  }

}
